/* money.js · fonte única de formatação de moeda (browser + Node). */
(function (root, factory) {
  var api = factory();
  root.SXE = root.SXE || {};
  root.SXE.formatMoney = api.formatMoney;
  if (typeof module !== 'undefined' && module.exports) { module.exports = api; }
})(typeof self !== 'undefined' ? self : this, function () {
  function withDelimiters(cents, precision, thousands, decimal) {
    if (cents == null || isNaN(cents)) cents = 0;
    var number = (cents / 100).toFixed(precision);
    var parts = number.split('.');
    var intPart = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    var decPart = parts[1] ? decimal + parts[1] : '';
    return intPart + decPart;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') { cents = parseInt(cents.replace(/[^0-9-]/g, ''), 10); }
    var fmt = format
      || (typeof self !== 'undefined' && self.SXE && self.SXE.moneyFormat)
      || 'r$ {{amount_with_comma_separator}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    var match = fmt.match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount': value = withDelimiters(cents, 2, ',', '.'); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", ','); break;
      default: value = withDelimiters(cents, 2, '.', ',');
    }
    return fmt.replace(placeholder, value).toLowerCase();
  }

  return { formatMoney: formatMoney };
});
